var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoxbet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1019.5 291.6",
    style: {
      enableBackground: "new 0 0 1019.5 291.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFDC04;}\n\t.st2{fill:#193052;}\n\t.st3{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "477.5,54.3 420.8,54.3 399.1,93.8 377.9,54.3 319.3,54.3 370.6,142.7 316.3,237.3 373.3,237.4  398.5,191 424,237.3 482.5,237.3 427.3,142.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "167.9,104.2 164.5,54 54,54 54,237.6 105.8,237.6 105.6,178.2 156.5,178.2 156.5,128.2 106.1,128.2  106.1,104.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M343.1,146c0.5-48.8-38.7-88.8-87.6-89.3h-0.1c-48.8,0.5-87.9,40.5-87.5,89.3c0,48.4,39.2,87.6,87.6,87.6 S343.1,194.4,343.1,146z M271.1,182.7c-0.3,8.3-7.1,14.9-15.4,14.9c-8.3-0.1-14.9-6.9-14.9-15.1v-73.1c-0.1-8.4,6.4-15.4,14.8-15.9 c8.5,0.4,15.3,7.3,15.5,15.9V182.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.5,233.6c48.4,0,87.6-39.2,87.6-87.6c0.5-48.8-38.7-88.8-87.6-89.3h-0.1c-48.8,0.5-87.9,40.5-87.5,89.3 C168,194.4,207.2,233.6,255.5,233.6z M240.8,109.3c-0.1-8.4,6.4-15.4,14.8-15.9c8.5,0.4,15.3,7.3,15.5,15.9v73.4 c-0.3,8.3-7.1,14.9-15.4,14.9c-8.3-0.1-14.9-6.9-14.9-15.1V109.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "316.3,237.3 373.3,237.4 398.5,191 424,237.3 482.5,237.3 427.3,142.1 477.5,54.3 420.8,54.3  399.1,93.8 377.9,54.3 319.3,54.3 370.6,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "105.6,178.2 156.5,178.2 156.5,128.2 106.1,128.2 106.1,104.2 167.9,104.2 164.5,54 54,54 54,237.6  105.8,237.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M989.5,24H520.1H30h-6v6v231.6v6h6h495.4h464.2h6v-6V30v-6H989.5z M661.1,157.6c5.4,8,7.8,17.5,7.8,27.1 c0,8.1-1.2,16.1-4.4,23.5c-2.9,6.5-7.4,12.1-13.1,16.5c-6,4.5-12.8,7.8-20.1,9.7c-8.5,2.2-17.3,3.3-26.2,3.2H528V54h77.6 c20.5,0,35.7,4.5,45.3,13.5c9.8,9.1,14.6,22,14.6,35.3c0,8.5-1.8,16.8-6.1,24.2c-3.9,6.5-9.6,11.7-16.3,15.3v0.6 C650.5,145.8,656.8,150.9,661.1,157.6z M793.7,125.4v39.3h-63.3v30.8h76.6v42H681.1V54h125.9v42.1h-76.6v29.3H793.7z M965.5,96.2 h-49.2v141.4h-47.7V96.2h-49.2l2.8-42.1h143.2V96.2z M30.4,261.6V142.1V30h489.8L456,142.1l69.3,119.5H30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M618.2,108.8c0-12.6-7.3-18.9-21.8-18.9h-20.7v37.8h20.7C611,127.8,618.2,121.5,618.2,108.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.1,160.5c-5.9,0-23.4,0-23.4,0v41.3h23.4c15,0,22.4-6.9,22.4-20.8c0-5.9-1.7-11-5.5-15 C611.3,162,605.6,160.5,599.1,160.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoxbet);
export default __webpack_public_path__ + "static/media/foxbet.5bfb6d8e428f41b7ca1c2a3870bde11d.svg";
export { ForwardRef as ReactComponent };